import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { MainForm } from 'AppSrc/core/components/forms/main-form';
import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';


class CreateCrqScreenDisplay extends React.PureComponent {

  constructor(props) {
    super(props);
    this.navigateToStep = this.navigateToStep.bind(this);
    this.navigateToCreateCrqSectionOne = this.navigateToCreateCrqSectionOne.bind(this);
  }

  // MM: step index is always set
  // crqNetwork is set on some screens only
  navigateToStep(stepIndex, crqNetwork) {

    // MM the step coming from the form is 0 indexed, but in the url path it is 1 indexed
    const networkPath = crqNetwork ? crqNetwork : this.props.crqNetwork;
    // console.log('*** CreateCrq NAVIGATE to STEP, ?crqNetwork? : ', stepIndex + 1, networkPath, this.props.history);
    // for the first step, go back to the create CRQ root url
    if (stepIndex === 0) {
      this.props.history.push('/crq/create');
    }
    // for subsequent steps, a network type path is required
    else if (stepIndex > 0 && networkPath) {
      this.props.history.push(`/crq/create/${(networkPath === 'fixedOlo' || networkPath === 'fixedInternational') ? 'fixed' : networkPath}/${stepIndex + 1}`);
    }
    else {
      console.warn('CREATE CRQ navigateToStep PATH INCOMPLETE!!! ');
    }
  }

  navigateToCreateCrqSectionOne() {
    this.props.history.push('/crq/create/');
  }

  render() {
    const {
      stepId,
      history,
    } = this.props;

    return (
      <div className="create-crq-screen">
        <MainForm
          formType={CREATE_CRQ}
          sectionIndex={stepId - 1}
          navigateToSection={this.navigateToStep}
          navigateToCreateCrqSectionOne={this.navigateToCreateCrqSectionOne}
          history={history}
        />
      </div>
    );
  }
}

CreateCrqScreenDisplay.propTypes = {
  // match: ReactRouterPropTypes.match.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  stepId: PropTypes.number,
  crqNetwork: PropTypes.string,
};


/* --- CreateCrq container component --- */

// the parent components can still pass props directly to the presentational component, and mapStateToProps can access them as ownProps
// the presentational component does not know whether its props come from the parent (ownProps) or the container, the difference is only visible in mapStateToProps
const mapStateToProps = (state, ownProps) => {

  // default to 1 when step unspecified
  const stepId = (ownProps.match && ownProps.match.params && ownProps.match.params.stepId) ? parseInt(ownProps.match.params.stepId) : 1;
  const crqNetwork = (ownProps.match && ownProps.match.params && ownProps.match.params.crqNetwork) ? ownProps.match.params.crqNetwork : null;
  // console.log('CreateCrq STEP, NETWORK, ownProps: ', stepId, crqNetwork, ownProps);
  window.sessionStorage.removeItem('getCurrentAdjacentRemedyRef');
  window.sessionStorage.removeItem('statusReason');
  window.sessionStorage.removeItem('relatedCRQId');
  return {
    stepId,
    crqNetwork,
  };
};

const CreateCrqScreen = withRouter(connect(
  mapStateToProps,
)(CreateCrqScreenDisplay));


export {
  CreateCrqScreenDisplay,
  CreateCrqScreen,
};
